export default __webpack_public_path__ + "static/product6-6615fab46413e426e60329830e5855ab.jpg";